import { PublicCardData } from '../models';

export const getImageBase64FromUrl = async (url: string) => {

  console.log("Vicman:: Desde getImageBase64FromUrl");

  const data = await fetch(url, {
     mode: 'no-cors' // Integrado por Vicman el 20250124 ya que originalmemte generaba error
  });
  const blob = await data.blob();
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = function () {
      const base64data = reader.result;
      resolve(base64data);
    };
  });
};

export const vCard = (
  image: string,
  publicCardData: PublicCardData,
  site: string
) => {
  let textoVcard = `BEGIN:VCARD
VERSION:3.0
FN;CHARSET=utf-8:${publicCardData.nombre}
TITLE;CHARSET=utf-8:${publicCardData.profesion}
ROLE;CHARSET=utf-8:${publicCardData.profesion}
EMAIL;Email:${publicCardData.correo}
TEL;WORK:${'+' + publicCardData.claveTelefono + ' ' + publicCardData.telefono}
TEL;TYPE=cell:${
    '+' + publicCardData.claveTelefono + ' ' + publicCardData.telefono
  }
TEL;TYPE=cell:
ADR;TYPE=HOME;LABEL="${publicCardData.domicilio}":;;${publicCardData.domicilio}
URL:${site}
URL;Homepage:${site}
PHOTO;ENCODING=b;TYPE=JPEG:${image}
END:VCARD`;
  return textoVcard;
};

export const downloadVCard = (fileName: string, vCard: string) => {
  var element = document.createElement('a');
  element.setAttribute(
    'href',
    'data:text/x-vcard;charset=iso-8859-1,' + encodeURIComponent(vCard)
  );
  element.setAttribute('download', fileName);
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};
